export default __webpack_public_path__ + "static/media/desktop_84.909cb41f.jpg";